import { cleanupOrphanedModalArtifacts } from "../../../modal/cleanup-orphaned-modal-artifacts";

/**
 * Clears Bootstrap artifacts left behind by an appointment modal interrupted
 * by an Inquiry Summary refresh. This is intentionally scoped to that screen;
 * ModalProvider now runs the same sweep whenever the last modal closes.
 */
export const cleanupOrphanedAppointmentModalArtifacts = (): void => {
  cleanupOrphanedModalArtifacts();
};
